import origMoment from 'moment';
import { extendMoment } from 'moment-range';
const momentRange = extendMoment(origMoment);

export default momentRange;